(function(){
"use strict";
/* KIRA CASES V4 – referenciar acabados con animación CSS ORIGINAL.
 * Activo en fichas de funda, salvo ?kira_editorial=0; nunca toca radios, precios,
 * estados, modelos, combos o eventos comerciales de Globo.
 * Mueve una sola sección real en el DOM debajo del grupo de impresión.
 * Si el grupo no se identifica, la sección permanece en su ubicación original. */
if(new URLSearchParams(location.search).get("kira_editorial")==="0")return;
const $=(sel,root=document)=>root.querySelector(sel);
const $$=(sel,root=document)=>Array.from(root.querySelectorAll(sel));
const norm=s=>String(s||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/\s+/g," ").trim().toUpperCase();
function earlier(a,b){
 if(!a||!b||a===b)return false;
 return !!(a.compareDocumentPosition(b)&Node.DOCUMENT_POSITION_FOLLOWING);
}
function sourceGuide(){
 const heading=$("#kp-acabados-header");
 const guide=heading?.closest(".kp-section");
 if(!guide || $$(".kp-finish-card",guide).length!==5)return null;
 return guide;
}
function hasRealFinishes(group,type,caseCard){
 if(!group || !group.isConnected || group.contains(type) || group===type)return false;
 if(group.closest(".kp-section") || group.querySelector(".kira-tipo-funda,.kira-marcas"))return false;
 if(!earlier(type,group))return false;
 if(caseCard && !earlier(caseCard,group))return false;
 // Evitar ancestros grandes que contengan múltiples grupos de productos.
 if(group.querySelector(".add-to-cart-button,.buy-buttons-block,.kira-case-context"))return false;
 if($$("img",group).length<2)return false;
 const name=norm(group.textContent);
 return name.includes("FOTOGRAFICO") && (name.includes("HOLOGRAFICO")||name.includes("GLOW"));
}
function findFinishGroup(info){
 const type=$(".kira-tipo-funda",info);
 if(!type)return null;
 const caseCard=$("#kira-case-context",info);
 const tagged=$$(".kira-acabados",info);
 for(const el of tagged){
  if(hasRealFinishes(el,type,caseCard))return el;
 }
 const heads=$$("label,legend,h2,h3,h4,span,p,div,.gpo-label,.gpo-option-title,.gpo-form__label",info);
 for(const h of heads){
  if(h.children.length>2 || !h.textContent || h.textContent.length>130)continue;
  const text=norm(h.textContent);
  if(!(/(?:ESCOGE|ELIGE|SELECCIONA)\s+(?:(?:EL|TU)\s+)?(?:ESTILO DE IMPRESION|ACABADO DE IMPRESION)/.test(text)||text.startsWith("ACABADOS DE IMPRESION")))continue;
  let el=h;
  for(let depth=0;el && depth<8 && el!==info;depth++,el=el.parentElement){
   if(hasRealFinishes(el,type,caseCard))return el;
   // No ascender a un elemento que englobe el selector de funda o el botón de compra.
   if(el.contains(type)||el.querySelector(".add-to-cart-button,.buy-buttons-block"))break;
  }
 }
 // Respaldo: localizar dos opciones reales y su ancestro común compacto.
 const leaves=$$("label,span,p,strong,div",info).filter(el=>
  el.childElementCount===0 && el.textContent?.trim().length<90 &&
  /^(?:ACABADO\s+)?(?:FOTOGRAFICO HD|HOLOGRAFICO(?:\s+HD)?)\b/.test(norm(el.textContent))
 );
 for(const el of leaves){
  let ancestor=el.parentElement;
  for(let i=0;ancestor&&i<7;i++,ancestor=ancestor.parentElement){
   if(hasRealFinishes(ancestor,type,caseCard))return ancestor;
   if(ancestor===info || ancestor.contains(type))break;
  }
 }
 return null;
}
const brands=new Set(["IPHONE","SAMSUNG","HUAWEI","HUAWEI/HONOR","HONOR","MOTOROLA","XIAOMI","LG","OPPO","REALME","ONE PLUS","ZTE","VIVO","NOTHING PHONE","PIXEL","INFINIX","RED MAGIC","TECNO"]);
function labelModels(info){
 const groups=$$(".gpo-element,.gpo-form__group,[data-element-id],[data-option-id]",info);
 for(const el of groups){
  if(el.closest(".kira-marcas,.kira-tipo-funda,.kira-case-context,.kira-v4-finish-guide"))continue;
  if(!el.querySelector("select,[role='combobox'],.gpo-select,.gpo-dropdown,.gpo-dropdown-wrapper"))continue;
  const candidates=$$("label,legend,.gpo-label,.gpo-option-title,p,strong,span",el);
  for(const text of candidates){
   if(text.childElementCount||!text.textContent||text.textContent.trim().length>65)continue;
   if(!brands.has(norm(text.textContent)))continue;
   if(text.closest("button,[role='radio'],.kira-marcas"))continue;
   text.classList.add("kira-v3-model-label");
   break;
  }
 }
}
function clarifyType(info){
 const type=$(".kira-tipo-funda",info);
 if(!type)return;
 for(const node of $$("p,span,small,div",type)){
  if(node.children.length>0||node.dataset.kiraV4Help)continue;
  const text=norm(node.textContent);
  if(text.includes("ELIGE EL ACABADO QUE MAS TE GUSTE")&&text.includes("PROTECCION ANTISHOCK")){
   node.dataset.kiraV4Help="1";
   node.textContent="Elige tu tipo de funda. El acabado de impresión se selecciona después.";
  }
 }
}
let placed=false;
function mount(){
 const info=$(".product-information");
 const guide=sourceGuide();
 if(!info||!guide||!$(".kira-tipo-funda",info))return false;
 clarifyType(info);labelModels(info);
 if(guide.classList.contains("kira-v4-finish-guide")){
  placed=true;return true;
 }
 const target=findFinishGroup(info);
 if(!target)return false;
 // Fallback: never move into a child or wrapper of the TYPE selection.
 const type=$(".kira-tipo-funda",info),card=$("#kira-case-context",info);
 if(!hasRealFinishes(target,type,card))return false;
 // Place after the complete native finish group, NOT after type cards.
 target.insertAdjacentElement("afterend",guide);
 guide.classList.add("kira-v4-finish-guide");
 guide.dataset.kiraV4Position="below-native-finish";
 guide.setAttribute("aria-label","Comparación visual de acabados de impresión");
 placed=true;
 return true;
}
let running=false;
function refresh(){
 if(running)return;
 running=true;
 requestAnimationFrame(()=>{
  running=false;
  try{mount();}catch(err){
   // Restaurar la guía visual inferior si fallara la reubicación.
   console.warn("[KIRA V4] Se conserva guía nativa de referencia",err);
  }
 });
}
function start(){
 refresh();
 document.addEventListener("gpoRenderCompleted",refresh);
 document.addEventListener("change",refresh);
 const observer=new MutationObserver(()=>{
   if(!placed)refresh();
 });
 observer.observe(document.body,{childList:true,subtree:true});
 setTimeout(()=>observer.disconnect(),18000);
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});
else start();
})();